/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_$2 as $2,
  rec_JSXRuntime as JSXRuntime,
  rec_Qi as Qi,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_Y2 as Y2,
} from "../../runtime/index.jsx";
export function Componente_a4_97_52(e) {
  let t = (0, ReactCompiler.c)(11),
    { fila: n, activa: r, tamano: i } = e,
    a = r === void 0 || r,
    o = i === void 0 ? `h-11 w-11 text-sm` : i,
    s = $2(n.id, n.vacante ? null : n.fotoVersion, a);
  if (n.vacante) {
    let e = `flex shrink-0 items-center justify-center rounded-full border border-dashed border-(--text)/40 text-(--text) ${o}`,
      n;
    t[0] === Symbol.for(`react.memo_cache_sentinel`)
      ? ((n = <Qi className={`h-1/2 w-1/2`} />), (t[0] = n))
      : (n = t[0]);
    let r;
    return (
      t[1] === e
        ? (r = t[2])
        : ((r = <span aria-hidden={`true`} className={e} children={n} />),
          (t[1] = e),
          (t[2] = r)),
      r
    );
  }
  if (s) {
    let e = `shrink-0 rounded-full object-cover ${o}`,
      n;
    return (
      t[3] !== e || t[4] !== s
        ? ((n = <img src={s} alt={``} className={e} />),
          (t[3] = e),
          (t[4] = s),
          (t[5] = n))
        : (n = t[5]),
      n
    );
  }
  let c = `flex shrink-0 items-center justify-center rounded-full bg-(--accent-bg) font-semibold text-(--accent-texto) ${o}`,
    l;
  t[6] === n ? (l = t[7]) : ((l = Y2(n)), (t[6] = n), (t[7] = l));
  let u;
  return (
    t[8] !== c || t[9] !== l
      ? ((u = <span aria-hidden={`true`} className={c} children={l} />),
        (t[8] = c),
        (t[9] = l),
        (t[10] = u))
      : (u = t[10]),
    u
  );
}
